const userErrors = {
  clientIdNotFound: "ERROR 0001: Client Id Missing",
  invalidClientId: "ERROR 0002: Client Id Invalid",
};

const userErrorsMessages = {
  clientIdNotFound: (
    <>
      Missing ClientId. Please contact an administrator via email at{" "}
      <a href="mailto:DTection@keoghs.co.uk">DTection@keoghs.co.uk</a>.
    </>
  ),
  invalidClientId: (
    <>
      Invalid ClientId. Please contact an administrator via email at{" "}
      <a href="mailto:DTection@keoghs.co.uk">DTection@keoghs.co.uk</a>.
    </>
  ),
};

export { userErrors, userErrorsMessages };
